import { CryptoRegister } from "./crypto/register";
import { NormalRegister } from "./normal/register";

export function registerAll() {
    CryptoRegister();
    NormalRegister();
}
